import { atom } from 'jotai'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'
import { ThankYouScreen } from '../../views'

export type ScreenChangeInfo = {
	screen: ThankYouScreen
	field: 'title' | 'description'
	oldValue: string
	newValue: string
}

export const [thankYouScreensAtom, useThankYouScreensListener] = atomWithListeners<ThankYouScreen[] | undefined>([])

export const thankYouScreenSelectedIndexAtom = atom(0)
export const thankYouScreenDebounceValueAtom = atom(800)

export const thankYouScreenLifecycleAtom = atom<LifecycleState>('idle')
export const thankYouScreenSavingAtom = atom<PersistenceState>('idle')

export const thankYouScreenChangeCallbackAtom = atom<((info: ScreenChangeInfo) => void) | null>(null)
export const thankYouScreenResetCallbackAtom = atom<((thankYouScreen: ThankYouScreen) => Promise<void>) | null>(null)
export const thankYouScreenResetAllCallbackAtom = atom<(() => Promise<void>) | null>(null)

export const thankYouScreenIsGeneratingAtom = atom(
	(get) => get(thankYouScreenLifecycleAtom) === 'generating',
)
